import { CheckedAddress, NormalizedNumber } from '@sparkdotfi/common-universal'

import { Mode } from '../types'
import { Token } from '@/domain/types/Token'
import { WithdrawFromSavingsObjective } from '@/features/actions/flavours/withdraw-from-savings/types'
import { TransferFromUserFormNormalizedData } from '@/features/dialogs/common/logic/transfer-from-user/form'

export interface CreateObjectivesParams {
  formValues: TransferFromUserFormNormalizedData
  receiver: CheckedAddress | undefined
  mode: Mode
  savingsToken: Token
  savingsTokenBalance: NormalizedNumber
  shouldRedeem: boolean
}
export function createObjectives({
  formValues,
  receiver,
  mode,
  savingsToken,
  savingsTokenBalance,
  shouldRedeem,
}: CreateObjectivesParams): WithdrawFromSavingsObjective[] {
  return [
    {
      type: 'withdrawFromSavings',
      token: formValues.token,
      amount: shouldRedeem ? savingsTokenBalance : formValues.value,
      isRedeem: shouldRedeem,
      savingsToken,
      receiver,
      mode,
    },
  ]
}
